/**
 * D-38: credit in this month's 4(A) on purchases booked in an earlier month.
 *
 * A supplier who files late puts an earlier invoice on this month's 2B; the
 * purchase is carried forward until it matches, and its credit is claimed in
 * the month it does. Said on the screen because this month's register alone
 * would not explain the figure.
 */

const HEAD_ORDER = ['igst', 'cgst', 'sgst', 'cess'] as const

export type CarriedForward = {
  count: number
  fromPeriods: { period: string; count: number }[]
  /** Only heads that carry something, in return order. Paise. */
  amounts: { head: (typeof HEAD_ORDER)[number]; paise: number }[]
}

/** The carried-forward credit from a 4(A) cell, or null when there is none. */
export function carriedForward(cell: Record<string, unknown> | undefined): CarriedForward | null {
  const source = cell?.source as Record<string, unknown> | undefined
  const flag = source?.carried_forward as Record<string, unknown> | undefined
  const count = typeof flag?.count === 'number' ? flag.count : 0
  if (count <= 0) return null
  const periods = (flag?.from_periods ?? {}) as Record<string, unknown>
  const perHead = (flag?.per_head ?? {}) as Record<string, unknown>
  return {
    count,
    fromPeriods: Object.entries(periods)
      .filter(([, n]) => typeof n === 'number' && n > 0)
      .map(([period, n]) => ({ period, count: n as number })),
    amounts: HEAD_ORDER.flatMap((head) => {
      const value = perHead[head]
      return typeof value === 'number' && value !== 0 ? [{ head, paise: value }] : []
    }),
  }
}
